import { useEffect } from 'react';

const usePageSchema = (schemas: object[], key: string): void => {
  useEffect(() => {
    const existing = document.querySelectorAll(`script[data-schema="${key}"]`);
    existing.forEach(el => el.remove());
    schemas.forEach(schema => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', key);
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });
    return () => {
      document.querySelectorAll(`script[data-schema="${key}"]`).forEach(el => el.remove());
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default usePageSchema;
